module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"answer":"Answer"},"de":{"answer":"Antwort"},"fr":{"answer":"Réponse"},"it":{"answer":"Risposta"}}')
  delete Component.options._Ctor
}
